/**
 * SKU preset / 表单是否已预置镜像拉取认证（用户名、密码或开启私有认证开关）。
 * 仅有 registry.server（镜像 probe 常自动写入）不算预置，不锁输入框。
 */
export function hasPresetImagePullAuth(values?: Record<string, unknown> | null): boolean {
  if (!values || typeof values !== 'object') return false;

  const nested = values.registry as { username?: unknown; password?: unknown; insecureTLS?: unknown } | undefined;
  const username = String(nested?.username ?? values['registry.username'] ?? '').trim();
  const password = String(nested?.password ?? values['registry.password'] ?? '').trim();
  if (username || password) return true;

  const insecureTLS = nested?.insecureTLS ?? values['registry.insecureTLS'];
  return insecureTLS === true;
}
